// Le url del CDN Salabam incorporano la size nel path: per ottenere un'altra variante
// si sostituisce quel token.
const CDN_DEFAULT_SIZE = 'max500';
const GRID_SIZE = 'max800';
const LIGHTBOX_SIZE = 'max1024x768';

const image_variant = (url, size) =>
  (url || '').replace(CDN_DEFAULT_SIZE, size);

// La gallery rende la griglia a max800 e apre il lightbox a max1024x768.
export const gallery_image = (url) => ({
  url: image_variant(url, GRID_SIZE),
  large: image_variant(url, LIGHTBOX_SIZE),
});

export const carousel_image_url = (url) => image_variant(url, GRID_SIZE);

export const image_url = (image) => {
  if (typeof image === 'string') {
    return image;
  }
  const { url } = image || {};
  let resolved = '';
  if (typeof url === 'string') {
    resolved = url;
  }
  return resolved;
};

export const image_thumbnail = (image) => image.thumbnail || image_url(image);

export const image_large = (image) => image.large || image_url(image);
